import { useContext, useState } from 'react';
import styled from '@emotion/styled';
import { Card, Form, Select, Input, Button } from 'semantic-ui-react';
import { store } from '../store';
import {
  ADD_COLOR_GROUP,
  ADD_REFERENCE_COLOR,
  SET_PICKED_COLOR,
  SET_PICKING_COLOR,
} from '../types';

const ColorCard = () => {
  const [label, setLabel] = useState('');
  const [group, setGroup] = useState('');
  const { pickedColor, colorGroups, dispatch } = useContext(store);
  const close = () => {
    dispatch({ type: SET_PICKING_COLOR, payload: false });
    dispatch({ type: SET_PICKED_COLOR, payload: '' });
  };
  const addColor = () => {
    const color = {
      color: pickedColor,
      label: label || pickedColor,
      group: group.value || 'Uncategorized',
    };
    dispatch({ type: ADD_REFERENCE_COLOR, payload: color });
    close();
  };

  const handleAddition = (e, { value }) => {
    const newGroup = {
      value,
      text: value,
      key: value,
    };
    setGroup(newGroup);
    dispatch({ type: ADD_COLOR_GROUP, payload: newGroup });
  };

  const handleGroupChange = (e, selectedGroup) => setGroup(selectedGroup);

  return (
    <CardContainer>
      <Card>
        <Card.Content>
          <Color color={pickedColor} />
        </Card.Content>
        <Card.Content>
          <Card.Header as="h2">{pickedColor}</Card.Header>
          <Form size="small">
            <Form.Group>
              <Input
                placeholder="Color Label"
                value={label}
                onChange={({ target }) => setLabel(target.value)}
                width={40}
              />
              <Select
                options={colorGroups}
                placeholder="Color Group"
                search
                fluid
                allowAdditions
                value={group.value}
                onAddItem={handleAddition}
                onChange={handleGroupChange}
              />
            </Form.Group>
            <Form.Group>
              <Button onClick={close}>Cancel</Button>
              <Button primary onClick={addColor}>
                Save Color
              </Button>
            </Form.Group>
          </Form>
        </Card.Content>
      </Card>
    </CardContainer>
  );
};

const CardContainer = styled.div({
  position: 'absolute',
  top: 70,
  left: 0,
  zIndex: 1,
});

const Color = styled.div(({ color }) => ({
  backgroundColor: color,
  width: '100%',
  height: 250,
}));

export default ColorCard;
